/**
 * 파일명 : cod0101m.tsx
 * 설명 : 코드관리 화면
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 * 1.0       2025-03-11   남주명     최초작성
 * 1.1       2025-03-26   남주명     model과 slice를 사용하도록 변경
 */

/************************************************
 * Import 영역  
 ************************************************/
/*  React  */
import React, { useReducer, useEffect } from "react";

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Cod0101mAction } from '../../../redux/slice/cod/cod0101m_slice';

/*  AntD  */
import { Button, Collapse, Row, Col, Layout, Space, Input } from "antd";
import { SearchOutlined, CaretRightOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";

/*  업무  */
import * as CommonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';

/************************************************
 * 전역변수 영역
 ************************************************/
const Cod0101m = (props:any) => {
    /************************************************
     * 화면 초기화 영역  
     ************************************************/
	/** State / Ref / Reducer 선언 **/
    const dispatch = useAppDispatch();
    const inquiryCnds = useAppSelector((state) => state.Cod0101m.inquiryCnds);
    const selectedCdGrpRowKeys = useAppSelector((state) => state.Cod0101m.selectedCdGrpRowKeys);

    /* Render 변수 선언영역 */
    /* AntD */
    const { Content } = Layout;
    const { Panel } = Collapse;

    /**
    * 기능 : componentDidMount
    * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
    * param : 
    * return : None
    */
    React.useEffect(() => {
        fn_Search();
    }, []);

    /**
     * 기능 : 코드그룹목록 조회
     * param : 
     */
    const fn_Search = () => {
        const headers = common.getHeader('TRCOMR0903');
        const requestData = { ...inquiryCnds };

        CommonProxy.callAsyncSvc(requestData, {
            headers,
            success: (responseData: any) => {
                dispatch(Cod0101mAction.setCdGrpList(responseData.cdGrpItems));
            },
        });
    };

    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        const buttonName = e.currentTarget.name;

        switch (buttonName) {
            // case "btn_Reset":
            //     dispatch(Cod0101mAction.initState());
            //     break;

            // case "btn_Search":
            //     fn_Search();
            //     break;

            case "addCdGrpList":
                dispatch(Cod0101mAction.addCdGrpItem({ id: Date.now() }));
                break;

            case "minusCdGrpList":
                if (selectedCdGrpRowKeys.length > 0) {
                    dispatch(Cod0101mAction.removeCdGrpItemsByIndexes(selectedCdGrpRowKeys));
                } else {
                    common.openAlert({ title: "확인", contents: '선택된 행이 없습니다.' });
                }
                break;
        }
    };

    return (
        <>
            <Layout>
                <Content>
                    <Collapse
                        bordered={false}
                        defaultActiveKey={['1']}
                        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    >
                        <Panel header="검색조건" key="1">
                            <Row
                                align="middle"
                                justify="space-between"
                                style={{ marginTop: 10 }}
                            >
                                <Space>
                                    <Col>
                                        <Space>
                                            <label>코드그룹명</label>
                                            <Input
                                            placeholder="입력하세요"
                                            style={{ width: 150 }}
                                            value={inquiryCnds.codeGroupNm}
                                            onChange={(e) => dispatch(Cod0101mAction.setInquiryCnds({
                                                ...inquiryCnds,
                                                codeGroupNm: e.target.value
                                            }))}
                                            />
                                        </Space>
                                    </Col>
                                </Space>
                                <Col style={{ margin: 10, textAlign: 'right' }}>
                                    <Space>
                                        <Button
                                            name="btn_Reset"
                                            onClick={onClick}
                                            >
                                            초기화
                                        </Button>
                                        <Button
                                            name="btn_Search"
                                            icon={<SearchOutlined />}
                                            onClick={onClick}
                                            >
                                            조회
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Panel>
                    </Collapse>
                    {/* 코드그룹 목록 */}
                    <Collapse
                        bordered={false}
                        defaultActiveKey={['1']}
                        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    >
                        <Panel header="코드그룹 목록" key="1">
                            <Row align="middle" style={{ height: 50 }}>
                                <Col style={{ textAlign: 'right' }}>
                                    <Space>
                                        <Button name="addCdGrpList" size="small" icon={<PlusOutlined />} onClick={onClick} />
                                        <Button name="minusCdGrpList" size="small" icon={<MinusOutlined />} onClick={onClick} />
                                    </Space>
                                </Col>
                            </Row>
                        </Panel>
                    </Collapse>
                </Content>
            </Layout>
        </>
    );
};

export default Cod0101m;
